import { Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { getLazyLoading } from "@/lib/utils";

interface IntroConsultationCardProps {
  priceLabel: string;
  onBook: () => void;
  title?: string;
  description?: string;
  details?: string;
  buttonLabel?: string;
}

export function IntroConsultationCard({
  priceLabel,
  onBook,
  title = "Prima Sessione Online Gratuita",
  description = "Un'opportunità per conoscerci, comprendere le tue esigenze e valutare insieme se il percorso di counselling è adatto a te.",
  details = "L'appuntamento si svolge sempre online, è completamente gratuito per i nuovi clienti e permette di esplorare insieme obiettivi e bisogni senza impegno.",
  buttonLabel = "Prenota qui",
}: IntroConsultationCardProps) {
  const imageLoading = getLazyLoading();

  return (
    <Card className="border-none shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 flex flex-col">
      <div className="aspect-[4/3] relative overflow-hidden">
        <picture>
          <source srcSet="/hero-session.webp" type="image/webp" />
          <img
            src="/hero-session.jpg"
            alt="Prima sessione online gratuita"
            width={400}
            height={300}
            loading={imageLoading}
            decoding="async"
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
          />
        </picture>
      </div>
      <CardHeader>
        <h2 className="text-2xl font-serif font-semibold">{title}</h2>
      </CardHeader>
      <CardContent className="flex flex-col flex-1">
        <p className="text-lg text-muted-foreground mb-4">{description}</p>
        <p className="text-lg text-muted-foreground mb-6">{details}</p>
        <div className="mt-auto flex flex-col gap-4">
          <div className="flex items-center gap-2 text-primary font-semibold text-lg">
            <Clock className="w-5 h-5 shrink-0" />
            <span>60 minuti - {priceLabel}</span>
          </div>
          <Button
            size="lg"
            onClick={onBook}
            className="text-base px-10 py-6 uppercase tracking-wide"
          >
            {buttonLabel}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
